
import Vue from 'vue'
import Confirm from '@/components/confirm/confirm.vue'
import faculty from '@/components/faculty/faculty.vue'
import myBottom from '@/components/myBottom/bottom.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

export default {
name: 'todoPage',
directives: {
TransferDom
},
components: {
'Confirm': Confirm,
'faculty': faculty,
'myBottom': myBottom,
Popup,
Swipeout,
SwipeoutItem,
SwipeoutButton,
Datetime,
InlineXSwitch,
Group,
XTextarea,
XDialog,
Previewer,
Icon
},
data () {
return {
keyword: '',
facultyItem: '',
collegeId: '',
collegeName: '院系',
showAuditType: false,
auditType: '待审核',
auditId: 1,
auditStatus: {
value: 1,
name: '待审核'
}, // 存储选中的值
showFilter: false,
auditTypeList: [
{
value: '',
name: '全部'
}, {
value: 1,
name: '待审核'
}, {
value: 2,
name: '已通过'
}, {
value: 3,
name: '被拒绝'
}
],
auditClassList: [
{
value: 1,
name: '事假'
}, {
value: 2,
name: '病假'
}, {
value: 3,
name: '公假'
}
],
list: [],
filterDate: {
startTime: '',
endTime: ''
},
leaveId: '',
refusalReason: '',
showRefuse: false,
showAgree: false,

isGuid: false,
hasUserInfo: false,
refuseModel: false,
date: '2018-09-01',
show1: false,
isshow: false,
confirmtype: 1,
confirmtitle: '',
confirmconten: '',
leftTime: '',
value: false,
facultyList: false,
actvType: false, // 选择活动类型展示状态
reportType: false,
contentTag: false,
actvLevel: false,
leftTimeModel: false,
showactvtypeItem: '',
showactvtypeChildItem: '',
actvtypeItem: '',
actvtypeChildItem: '',
reportTypeIndex: '',
showreportTypeIndex: '',
contentTagIndex: '',
showcontentTagIndex: '',
showlevelTypeIndex: '',
levelTypeIndex: '',
handleType: '',
handleItem: {},
page: 0,
total: 0,
actvTypeList: [],
actvTypeChildList: [],
collegeList: [],
refuseReason: '',
levelList: [{
type: 0,
name: '院系'
},
{
type: 1,
name: '校级'
},
{
type: 2,
name: '市级'
},
{
type: 3,
name: '省级'
},
{
type: 4,
name: '国家级'
}
],
contentTagList: [{
type: 1,
name: '色情低俗'
},
{
type: 2,
name: '广告'
},
{
type: 3,
name: '与事实不符'
},
{
type: 4,
name: '人身攻击'
},
{
type: 5,
name: '垃圾信息'
},
{
type: 6,
name: '违法'
},
{
type: 7,
name: '活动作弊'
},
{
type: 8,
name: '其他'
}
],
reportTypeList: [{
type: 1,
name: '花絮'
},
{
type: 2,
name: '活动'
},
{
type: 3,
name: '评论'
},
{
type: 4,
name: '活动成员'
}
],
leftTimeList: [{
type: 1,
name: '1小时内'
},
{
type: 2,
name: '24小时内'
},
{
type: 3,
name: '72小时内'
},
{
type: 4,
name: '1周内'
},
{
type: 5,
name: '1周后'
}],
activitybegintime: '',
activityendtime: '',
menuList: [],

options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
noData: false
}
},
watch: {
showRefuse: function (val) {
if (!val) {
this.refusalReason = ''
}
}
},
created () {
this.getActvTypeList()
this.getMenu()
},
methods: {
searchLeaveList () {
this.noData = false
this.getLeaveList(1)
},
resetAuditType () {
this.auditStatus = {
value: '',
name: '全部'
}
this.auditType = '全部'
this.auditId = 1
},
logIndexChange (arg) {
console.log(arg)
},
show (id, index) {
this.$refs[`previewer-${id}`][0].show(index)
},
throughLeave () {
var params = new URLSearchParams()
params.append('leaveId', this.leaveId)
params.append('status', 2)
this.$http({
method: 'post',
url: '/leave/check',
params: params
}).then(res => {
if (+res.code === 100) {
this.$vux.toast.text('已同意请假申请！')
this.showAgree = false
this.noData = false
this.getLeaveList(1)
}
}).catch(error => {
console.log(error)
})
},
refuseLeaveHandle () {
if (!this.refusalReason) {
this.$vux.toast.text('请填写拒绝理由！')
return false
}
var params = new URLSearchParams()
params.append('leaveId', this.leaveId)
params.append('status', 3)
params.append('refuseContent', this.refusalReason)
this.$http({
method: 'post',
url: '/leave/check',
params: params
}).then(res => {
if (+res.code === 100) {
this.$vux.toast.text('已拒绝！')
this.showRefuse = false
this.noData = false
this.getLeaveList(1)
}
}).catch(error => {
console.log(error)
})
},
refuseLeave (id) {
this.leaveId = id
this.showRefuse = true
},
agreeLeave (id) {
this.leaveId = id
this.showAgree = true
},
filterAuditType (value) {
for (let i = 0; i < this.auditTypeList.length; i++) {
const item = this.auditTypeList[i]
if (item.value === value) {
return item.name
}
}
},
filterClassType (value) {
for (let i = 0; i < this.auditClassList.length; i++) {
const item = this.auditClassList[i]
if (item.value === value) {
return item.name
}
}
},
selectType (item) {
this.auditStatus = item
},
auditConfirm () {
this.auditType = this.auditStatus.name
this.auditId = this.auditStatus.value
this.showAuditType = false
this.noData = false
this.getLeaveList(1)
},
resetCollege () {
this.collegeId = ''
this.collegeName = '院系'
this.$refs.faculty.onReset()

},
collegeConfirm (item) {
if (JSON.stringify(item) !== '{}') {
this.collegeId = item.id
this.collegeName = item.name
} else {
this.collegeId = ''
this.collegeName = '院系'
}
this.facultyList = false
this.noData = false
this.getLeaveList(1)
},
knowGuid: function () {
this.isGuid = false
this.setCookie('isGuidFlag', '1', 9999999)
},
confirmItem (type, item) {
switch (type) {
case 'actvtype':
if (Object.keys(this.showactvtypeItem).length === 0) {
this.actvtypeItem = ''
this.actvtypeChildItem = ''
this.actvType = false
return
}
if (Object.keys(this.showactvtypeChildItem).length === 0) {
this.$vux.toast.text('请选择活动二级分类')
return
}
this.actvtypeItem = this.showactvtypeItem
this.actvtypeChildItem = this.showactvtypeChildItem
this.actvType = false
break
case 'level':
this.levelTypeIndex = this.showlevelTypeIndex
this.actvLevel = false
break
case 'contenttag':
this.contentTagIndex = this.showcontentTagIndex
this.contentTag = false
break
case 'reporttype':
this.reportTypeIndex = this.showreportTypeIndex
this.reportType = false
break
case 'lefttime':
this.leftTime = item
this.leftTimeModel = false
break
default:

break
}
},
resetItem (type) {
switch (type) {
case 'actvtype':
this.showactvtypeItem = ''
this.showactvtypeChildItem = ''
this.actvTypeChildList = []
break
case 'level':
this.showlevelTypeIndex = ''
break
case 'contenttag':
this.showcontentTagIndex = ''
break
case 'reporttype':
this.showreportTypeIndex = ''
break
default:
break
}
},
getMenu () {
this.$http({
method: 'post',
url: '/workorder/ordertype/menu'
}).then(res => {
this.menuList = res.result
}).catch(error => {
console.log(error)
})
},
changeType1 (item) {
this.showactvtypeItem = item
this.showactvtypeChildItem = ''
this.actvTypeChildList = item.list
},
getActvTypeList () {
var params = new URLSearchParams()
params.append('schoolId', this.getCookie('schoolid'))
this.$http({
method: 'post',
url: '/workorder/activity/cataloglist',
params: params
}).then(res => {
this.actvTypeList = res.result
}).catch(error => {
console.log(error)
})
},
infinite (done) {
const that = this
if (that.noData) {
that.$refs.myscroller.finishInfinite(true)
return false
}
this.page++
this.getLeaveList(this.page, done)
},
refresh (done) {
this.page = 0
this.noData = false
this.getLeaveList(1, done)
},
todetail (item) {
if (item.orderType === '1') {
this.$router.push({ path: '/actvDetail', query: { orderid: item.id, activityId: item.refId } })
} else if (item.orderType === '4') {
this.$router.push({ path: '/handleRecord', query: { id: item.refId } })
} else if (item.orderType === '3') {
this.$router.push({ path: '/handleReport', query: { id: item.refId } })
} else {
this.$router.push({ path: '/handleReply', query: { id: item.refId } })
}
},
getLeaveList (page, done) {
this.page = page
var params = new URLSearchParams()
params.append('keyword', this.keyword || '')
params.append('collegeId', this.collegeId || '')
params.append('startTime', this.filterDate.startTime != null && this.filterDate.startTime ? `${this.filterDate.startTime}:00` : '')
params.append('endTime', this.filterDate.endTime != null && this.filterDate.endTime ? `${this.filterDate.endTime}:00` : '')
params.append('status', this.auditId)
params.append('page', page)
params.append('rows', '20')
this.$http({
method: 'post',
url: '/leave/list',
params: params
}).then(res => {
let leaveData = res.result.rows
leaveData.forEach((item) => {
item.expand = false
item.imgArr = []
if (item.img) {
for (let i = 0; i < item.img.split(',').length; i++) {
item.imgArr.push({
msrc: item.img.split(',')[i],
src: item.img.split(',')[i]
})
}
}
})
if (page === 1) {
this.list = leaveData
done && done()
if (this.page >= res.result.total) {
this.noData = true
} else {
this.$refs.myscroller.finishPullToRefresh()
this.$refs.myscroller.finishInfinite(false)
this.noData = false
}
} else {
this.list = this.list.concat(leaveData)
done && done()
if (this.page >= res.result.total) {
this.noData = true
} else {
this.$refs.myscroller.finishInfinite(false)
}
}
this.total = res.result.total
}).catch(error => {
console.log(error)
})
},
schoolConfirm (item) {
if (item.name) {
this.facultyItem = item
} else {
this.facultyItem = ''
}
this.facultyList = false
},
handleswipe (type, item) {
this.handleType = type
this.handleItem = item
switch (type) {
case 1:
this.confirmtitle = '通过活动审核'
this.confirmconten = '是否确认通过该活动的审核请求？'
break
case 2:
this.confirmtitle = '驳回活动审核'
this.confirmconten = '是否确认驳回该活动的审核请求？'
break
case 3:
this.confirmtitle = '通过密码申诉'
this.confirmconten = '是否确认通过用户（' + item.name + '）的密码申诉，通过后会将该学生密码修改生成 8 位随机密码，并发送到当前学生填写手机号！'
break
case 4:
this.confirmtitle = '拒绝密码申诉'
this.confirmconten = '拒绝申诉请求后将会通过短信方式发送申诉失败提醒至学生手机。是否确认拒绝该用户的申诉请求？'
break
}
this.isshow = true
},
clearTimeRange () {
this.filterDate.startTime = ''
this.filterDate.endTime = ''
},
confimrange () {
if (this.filterDate.startTime === '' && this.filterDate.endTime !== '') {
this.$vux.toast.text('请输入开始时间')
return
}
if (this.filterDate.startTime !== '' && this.filterDate.endTime === '') {
this.$vux.toast.text('请输入结束时间')
return
}
if (this.filterDate.startTime === '' && this.filterDate.endTime === '') {
this.show1 = false
if (this.showFilter) {
this.activitybegintime = ''
this.activityendtime = ''
} else {
this.noData = false
this.getLeaveList(1)
}
return
}
if (this.filterDate.startTime >= this.filterDate.endTime) {
this.$vux.toast.text('结束时间需要大于开始时间！')
} else {
this.show1 = false
if (this.showFilter) {
this.activitybegintime = this.filterDate.startTime
this.activityendtime = this.filterDate.endTime
} else {
this.noData = false
this.getLeaveList(1)
}
}
},
confimFilter () {
this.noData = false
this.getLeaveList(1)
this.showFilter = false
},
confirm () {
let params = new URLSearchParams()
params.append('orderid', this.handleItem.id)
let data = new URLSearchParams()
data.append('id', this.handleItem.refId)
switch (this.handleType) {
case 1:
this.$http({
method: 'post',
url: '/workorder/activity/passcheck',
params: params
}).then(res => {
if (+res.code === 100) {
this.$vux.toast.text('操作成功，活动审核已通过')
this.refuseModel = false
this.noData = false
this.getLeaveList(1)
} else {
this.$vux.toast.text(res.result.msg || res.result)
this.refuseModel = false
}
}).catch(error => {
console.log(error)
})
break
case 2:
this.refuseModel = true
break
case 3:
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/passcheck',
params: data
}).then(res => {
if (res.success) {
this.$vux.toast.text('操作成功，已通过该密码申诉')
this.noData = false
this.getLeaveList(1)
} else {
this.$vux.toast.show({
type: 'warn',
text: res.result.msg || res.result
})
}
this.isshow = false
}).catch(error => {
console.log(error)
})
break
case 4:
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/rejectcheck',
params: data
}).then(res => {
if (res.success) {
this.$vux.toast.text('操作成功，已拒绝该密码申诉')
this.noData = false
this.getLeaveList(1)
} else {
this.$vux.toast.show({
type: 'warn',
text: res.result.msg || res.result
})
}
this.isshow = false
}).catch(error => {
console.log(error)
})
break
}
this.isshow = false
},
refuseAply () {
if (this.refuseReason === '') {
this.$vux.toast.text('请输入您的活动审核理由')
} else {
var params = new URLSearchParams()
params.append('orderid', this.handleItem.id)
params.append('remarks', this.refuseReason)
this.$http({
method: 'post',
url: '/workorder/activity/rejectcheck',
params: params
}).then(res => {
if (+res.code === 100) {
this.$vux.toast.text('操作成功，活动审核已驳回')
this.refuseModel = false
} else {
this.$vux.toast.text(res.result.msg || res.result)
this.refuseModel = false
}
}).catch(error => {
console.log(error)
})
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/leaveList/leaveList.vue